import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.scrollToBottom()
    this.observeMutations()
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  scrollToBottom() {
    this.element.scrollTop = this.element.scrollHeight
  }

  isNearBottom() {
    return (this.element.scrollHeight - this.element.scrollTop - this.element.clientHeight) < 50
  }

  observeMutations() {
    this.observer = new MutationObserver(() => {
      if (this.isNearBottom()) {
        this.scrollToBottom()
      }
    })

    this.observer.observe(this.element, {
      childList: true,
      subtree: true
    })
  }
}
